import {
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import {
    CustomAttachmentFileName,
    GetAttachmentModel,
    GetAttachmentParameter,
} from "@tSurya/Services/SurGetCustomPropertiesService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<GetAttachmentParameter & HasOnSuccess<GetAttachmentModel>, GetAttachmentModel>;

export const DispatchBeginGetAttachment: HandlerType = props => {
    props.dispatch({
        type: "Custom/GetAttachmentFileName/BeginLoadGetAttachmentFileName",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await CustomAttachmentFileName(props.parameter);
};

export const DispatchCompleteGetAttachment: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/GetAttachmentFileName/CompletedLoadGetAttachmentFileName",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter?.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginGetAttachment,
    RequestDataFromApi,
    DispatchCompleteGetAttachment,
    ExecuteOnSuccessCallback,
];

const customAttachmentFileName = createHandlerChainRunner(chain, "SurCustomAttachmentFileName");
export default customAttachmentFileName;
